<ngx-loading [show]="loading"></ngx-loading>

<div #expandAll>
  <ng-container *ngIf="gridView?.total"
    ><kendo-svg-icon
      *ngIf="allCollapsed"
      class="expand-all-button"
      [icon]="plusIcon"
      [title]="'Expand All Details'"
      (click)="toggleExpandAll()"
    >
    </kendo-svg-icon>
    <kendo-svg-icon
      *ngIf="!allCollapsed"
      class="expand-all-button"
      [icon]="minusIcon"
      [title]="'Collapse All Details'"
      (click)="toggleExpandAll()"
    >
    </kendo-svg-icon
  ></ng-container>
</div>

<kendo-grid
  class="emr-kendo-grid hide-default-sort h-100"
  [data]="gridView"
  [style.maxHeight.%]="100"
  [pageSize]="gridState.take"
  [pageable]="true"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [sortable]="{
    allowUnsort: false,
    mode: 'single'
  }"
  [kendoGridExpandDetailsBy]="expandDetailsBy"
  [(expandedDetailKeys)]="expandedDetailKeys"
  (dataStateChange)="pageChange($event)"
  (excelExport)="onExcelExport($event)"
  #grid="kendoGrid"
>
  <kendo-grid-column field="packageName" title="Package" [width]="190">
    <ng-template kendoGridHeaderTemplate let-column>
      {{ column.title }}
      <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
      {{ dataItem.packageName ?? 'Custom' }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="serviceName" title="Service" [width]="190">
    <ng-template kendoGridHeaderTemplate let-column>
      {{ column.title }}
      <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="salesAmount" title="Sales" format="{0:c2}" [width]="130">
    <ng-template kendoGridHeaderTemplate let-column>
      {{ column.title }}
      <i class="ml-1" [ngClass]="sortIconClass(column)"></i>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column *ngFor="let tax of possibleTaxes" [field]="tax.name" [title]="tax.name" [width]="140">
    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
      {{ dataItem.taxCollected[tax.name] | currency }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-excel fileName="packages_report.xlsx" [fetchData]="allData"></kendo-grid-excel>
  <div *kendoGridDetailTemplate="let dataItem">
    <app-package-detail
      [clinicServiceTemplateId]="dataItem?.clinicServiceTemplateId"
      [packageId]="dataItem?.packageId"
      [possibleTaxes]="possibleTaxes"
    ></app-package-detail>
  </div>
</kendo-grid>
